export const LOCALE_PREFIX = 'components.ConnectionChecker'
